<template>
    <div class="title-group-page">
        <layout>
            <template v-slot:content >
                 <title-group />
            </template>
        </layout>
    </div>
</template>

<style lang="less" scoped>
@import 'TitleGroup';
</style>

<script>
import TitleGroup from './TitleGroup'
export default TitleGroup
</script>
